// extracted by mini-css-extract-plugin
export default {"housingInfo":"houseApplication_housingInfo__7-Okn","animated-pattern":"houseApplication_animated-pattern__J7nKk","container":"houseApplication_container__hgGlR"};